import { TEMPLATE_FILES, templateHref } from '../templateFile';

/** Stakeholder / local procurement allocation sheet — click downloads a copy. */
export const PROCUREMENT_LINKS = {
  supplierRegistration: {
    label: 'Register your supplier (local/group procurement tool)',
    href: templateHref(TEMPLATE_FILES.supplierAllocation),
  },
  procurementStandard: {
    label: 'ISS Procurement Standard',
    href: 'https://policyhub.issworld.com/policies-standards/group-procurement/iss-procurement-standard',
  },
} as const;
